<template>
  <label class="switch" :class="{ disabled: disabled, 'without-style-disabled': withoutStyleDisabled }">
    <input v-model="val" type="checkbox" :disabled="locked || disabled" @change="toggle" />
    <span v-if="locked" class="slider slider--lock" :class="{ disabled: disabled, 'without-style-disabled': withoutStyleDisabled }">
      <span class="text typo-body2">
        <slot name="locked">LOCKED</slot>
      </span>
    </span>
    <span v-else class="slider" :class="[toggleClass, { disabled: disabled, 'without-style-disabled': withoutStyleDisabled }]">
      <span class="text typo-body2">
        <!-- <slot name="on" v-if="val">YES</slot>
        <slot name="off" v-else>NO</slot> -->
      </span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'Toggler',
  props: {
    modelValue: Boolean,
    locked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    withoutStyleDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      val: false,
      // locked: false
    };
  },
  computed: {
    toggleClass() {
      return this.val ? 'on' : 'off';
    },
  },
  watch: {
    modelValue(newV) {
      if (this.val != newV) this.val = newV;
    },
  },
  created() {
    this.val = this.modelValue;
  },
  methods: {
    toggle() {
      this.$emit('update:modelValue', this.val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.switch {
  position: relative;
  display: inline-block;
  $width: 34px;
  $height: 18px;
  $padding: 1px;

  width: $width;
  height: $height;

  input {
    display: none;

    &:checked {
      & + .slider:not(.slider--lock) > .text {
        transition: all 0.2s;
        right: calc(32px + 13px);
        right: $height - $padding;
        left: auto;
      }

      & + .slider:not(.slider--lock):before {
        content: '';
        background-color: #ffffff;
        transform: translate($width - $height, -50%);
      }
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $cPrimary;
    transition: 0.2s;
    border-radius: 29px;
    user-select: none;
    box-shadow: 0px 7px 64px rgba(0, 0, 0, 0.1);

    &.off {
      background-color: $dark3;
    }

    &:before {
      position: absolute;
      content: '';
      height: $height - $padding * 2;
      width: $height - $padding * 2;
      left: 1px;
      bottom: 1px;
      background-color: #ffffff;
      border-radius: 50%;
      transition: all 0.2s;

      top: 50%;
      transform: translateY(-50%);
    }

    &.disabled:not(.without-style-disabled) {
      background-color: $text-light-disabled;
    }

    > .text {
      position: absolute;
      color: $grey2;
      transition: all 0.2s;
      // left: $height + 10px;
      right: 0;
      width: $width - $height + $padding;
      text-align: center;
      top: calc(40% - 5px);
      // right: auto;
      bottom: auto;
      font-size: 14px;
      user-select: none;
    }
  }

  .slider--lock {
    &:before {
      font-family: 'icomoon' !important;
      line-height: 1;
      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      @include flex-center;
      font-size: 16px;
      content: '\e915';
      background: $bg;
    }
  }

  &.disabled:not(.without-style-disabled) {
    pointer-events: none;
  }
}
</style>
